<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ counter }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block  v-if="$auth.check('ROLE_ADMIN')">+</v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Código</th>
          <th>Nome</th>
          <th>Host</th>
          <th>Interfaces</th>
          <th>ONTs</th>
          <th>UP</th>
          <th>DOWN</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.code }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.host }}</td>
          <td>
            <v-progress-circular indeterminate size="16" width="2" color="primary" v-if="item.loading"></v-progress-circular>
            <v-icon small color="error" title="falha ao consultar a OLT" v-else-if="item.error">mdi-alert-circle-outline</v-icon>
            <span v-else>{{ item.ports }}</span>
          </td>
          <td>{{ item.loading || item.error ? "-" : item.total }}</td>
          <td>{{ item.loading || item.error ? "-" : item.up }}</td>
          <td>{{ item.loading || item.error ? "-" : item.down }}</td>
          <td>
            <v-btn small color="primary" @click="view(item.id)"  v-if="$auth.check('ROLE_ADMIN')">configuração</v-btn>&nbsp;&nbsp;
            <v-btn small color="success" @click="admin(item.id)">administração</v-btn>&nbsp;&nbsp;
            <v-btn small color="warning" @click="status(item.id)">status</v-btn>&nbsp;&nbsp;
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    counter: 0
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/olt", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          //os contadores ja entram declarados para manterem a reatividade
          me.current = response.data.map(function(olt) {
            olt.ports = 0;
            olt.total = 0;
            olt.up = 0;
            olt.down = 0;
            olt.loading = true;
            olt.error = false;
            return olt;
          });
          me.counter = me.current.length;
          for (var i = 0; i < me.current.length; i++) {
            me.loadStatus(me.current[i]);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadStatus: function(item) {
      var token = localStorage.getItem("token");
      //as interfaces e os contadores de ONT so existem no status da OLT
      api
        .get("/olt/status/" + item.id, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          var list = response.data || [];
          for (var i = 0; i < list.length; i++) {
            item.total += list[i].total;
            item.up += list[i].active;
            item.down += list[i].inactive + list[i].invalid;
          }
          item.ports = list.length;
        })
        .catch(function(error) {
          item.error = true;
          console.log(error);
        })
        .finally(function() {
          item.loading = false;
        });
    },
    view: function(id) {
      this.$router.push({ path: `/olt/${id}` });
    },
    register: function() {
      router.push({ path: "/olt/0" });
    },
    admin: function(id) {
      this.$router.push({ path: `/olt/admin/${id}` });
    },
    status: function(id) {
      this.$router.push({ path: `/olt/status/${id}` });
    }
  }
};
</script>